import {
    setCurrentView,
    setNextView,
    setBackView,
    setRenderer,
    setDirection,
    setTransitionsProps,
    setTransitionsWithTarget,
    setIncomingView,
    setOutgoingView,
} from './setters';

import animatePageTransition, { cleanUpAnimation } from './animatePageTransition';
import renderTransitionView from './renderTransitionView';
import setViewFunc, { removeViewFunc } from './setViewFunc';
import views from './views';

export const actions = {
    setRenderer,
    setDirection,
    setCurrentView,
    setNextView,
    setBackView,

    setTransitionsProps,
    setTransitionsWithTarget,
    animatePageTransition,
    cleanUpAnimation,
    renderTransitionView,
    setViewFunc,
    removeViewFunc,
    setIncomingView,
    setOutgoingView,
    views,
};

export default actions;
